import { FlagApi } from './flag-api.model';

export class Flag {
  id: number;
  name: string;

  constructor(resource: FlagApi) {
    this.id = resource.id;
    this.name = resource.name;
  }
}
